"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blue = {
    darkSquare: "#708B9C",
    lightSquare: "#95AEC2"
};
